<template>
  <div class="top-bar">
    <button @click="backPage">Retour</button>

    <p v-if="activePage != 'level'">
      Vie:
      <heart />
    </p>
  </div>

  <chooseDifficulty v-if="activePage == 'level'" />
  <chooseFamily v-if="activePage == 'family'" />
  <chooseGame v-if="activePage == 'game'" />
  <questions v-if="activePage == 'quizz'" />
</template>

<script>
import { mapGetters } from "vuex";
import heart from "../components/Quizz/heart";
import chooseDifficulty from "../components/Quizz/chooseDifficulty";
import chooseFamily from "../components/Quizz/chooseFamily";
import chooseGame from "../components/Quizz/chooseGame";
import questions from "../components/Quizz/Questions/questions";

export default {
  name: "Quizz",
  components: {
    chooseDifficulty,
    chooseFamily,
    chooseGame,
    questions,
    heart,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      plants: "plants",
      life: "life",
      activePage: "activePage",
      difficulty: "difficulty",
      family: "family",
      game: "game",
      score: "score",
    }),
  },
  methods: {
    backPage() {
      this.$store.commit("backPage");
    },
  },
  mounted() {},
};
</script>
